import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import teamValidations from '../../../validators/team';
import { validatePresence } from 'ember-changeset-validations/validators';

export default class ResourcesTeamsCreateController extends Controller {
  @service router;
  @service intl;

  teamValidations = {
    ...teamValidations,
    name: [
      validatePresence({
        presence: true,
        message: 'Team name cannot be blank',
      }),
    ],
  };

  @action
  CloseDialog() {
    this.model.deleteRecord();
    this.router.transitionTo('settings.teams');
  }

  @action
  CloseAfterSubmit() {
    this.router.transitionTo('settings.teams');
  }

  @action
  handleCreateTeamDismiss() {
    this.model.deleteRecord();
    this.router.transitionTo('settings.teams.active');
  }

  @action
  async onSubmit(changeset, e) {
    e.preventDefault();
    try {
      changeset.validate();
      if (changeset.isInvalid) return;
      changeset.save().then(() => {
        this.router.transitionTo('settings.teams.active');
      });
    } catch (err) {
      console.log(err);
    }
  }

  @action
  setName(changeset, event) {
    changeset.set('name', event.target.value);
  }

  @action
  validateProperty(changeset, property) {
    return changeset?.validate(property);
  }
}
